import { TextField } from "@mui/material";
import React, { useState } from "react";
import { IoEye } from "react-icons/io5";
import { IoMdEyeOff } from "react-icons/io";
import "./Input.scss";
const Input = ({
  label,
  value,
  onChange,
  error,
  password,
  name,
  disabled,
  maxLength,
  extrafeild,
  onblur,
  type = "text",
}) => {
  const [passwordType, setPasswordType] = useState(true);
  return (
    <>
      <div className={extrafeild ? "input extrainput" : "input"}>
      <div className="inputFeild">
          <input
          

          name={name}
          disabled={disabled}
          onBlur={onblur}
          value={value}
          
          onChange={onChange}
          type={password ? (passwordType ? "password" : "text") : type}
          error={Boolean(error)}
          helperText={error ? "This field is required" : ""}
          maxLength={maxLength}
        />
        <label className={value !== "" ? "label active" : "label"} >
          {label}
        </label>
      </div>
        {extrafeild && <span className="extrafeild">
          {extrafeild}
        </span>}
        {password && (
          <span
            className="password-icon"
            onClick={() => setPasswordType(!passwordType)}
          >
            {!passwordType ? <IoEye /> : <IoMdEyeOff />}
          </span>
        )}
      </div>
    </>
  );
};

export default Input;
